import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';


export default class ScrollAnime{


    constructor(){
        this._init();
    }

    _init() {
        gsap.registerPlugin(ScrollTrigger);
        this._setScrollTrigger();
    }


    _setScrollTrigger() {
        
        [...document.querySelectorAll('.js-scrollreveal')].forEach($trigger => {
            const startpos = $trigger.getAttribute('data-start') ? $trigger.getAttribute('data-start') : 'top 70%';

            ScrollTrigger.create({
                trigger: $trigger,
                start: startpos,
                onEnter: () => {
                    $trigger.classList.add('-reveal');
                }
            });
        });
    }
}
